import orderBy from "lodash/orderBy";
import { getEventDates } from "@/common/utils/dateTime";

export const ypoEventConstant = {
    label: {
        MAIN_TITLE: 'Event Directory',
        CLEAR_ALL: 'Clear All',
        MY_CHAPTER_EVENTS_TITLE: 'My Chapter Events Only',
        MY_EVENTS_TITLE: 'My Events',
        REGISTER: 'Register',
        REGISTERED: 'Registered',
        WAITLISTED: 'Waitlisted',
        FILTER_SORT: 'Filter / Sort',
        VIRTUAL: 'Virtual',
        SORT_BY: 'Sort by Recommended',
        NO_RESULTS_FOUND: 'No matching',
        SEE_RESULTS: 'See Results',
        EVENT_RESULT_CARD_TITLE: 'Title',
        EVENT_RESULT_CARD_IMAGE: 'Image-Button',
    },
    constant: {
        searchResultOffsetStep: 50,
        searchResultMaxCount: 50,
        keys: {
            countryState: 'CountryState',
            countryStateCity: 'CountryStateCity',
            regionsDropDown: 'Regions',
            noStateOrProvince: 'NoStateOrProvince',
            locationType: 'LocationType',
            inPersonLocationType: 'In Person',
            virtualLocationType: 'Virtual',
            myEventsFilter: 'myEvents',
            eventFocusFilter: 'eventFocus',
            lifelongLearningFilter: 'lifelongLearningCategory',
            locationFilter: 'location',
            datesFilter: 'dates',
            hostFilter: 'sponsors',
            whoCanAttendFilter: 'whoCanAttend',
            voucherFilter: 'acceptsVoucher',
            startDateTimeRangeFrom: 'StartDateTimeRangeFrom',
            startDateTimeRangeTo: 'StartDateTimeRangeTo',
            globalEvent: 'IsGlobalEvent',
            attendeeIds : 'AttendeeIds',
            myChapters: 'myChapters',
            myNetworks: 'myNetworks',
            programOwner: 'ProgramOwner',
        },
        myChapterDefaultFilter: {
                "parentKey": "sponsors",
                "label": "My Chapters",
                "filterKey": "ChapterIds",
                "filterValue": "MyChapters",
                "isTypeAhead": false,
                "isDropdown": false,
                "subFilters": [],
                "count": 1,
                "ribbonGroupName": "Sponsors",                 
        },
    },
    defaultEventFilters: {
        location: [
            { 
              "label": "In Person",
              "filterKey": "LocationType",
              "filterValue": "In Person",
              "isDropdown": "false",
              "isTypeAhead": "false",
              "subFilters": [],
              "count": 10,
              "ribbonGroupName": "Location",
            },
        ],
        sponsors: [
            {
                "label": "Global Events",
                "filterKey": "IsGlobalEvent",
                "filterValue": "True",
                "subFilters": [],
                "count": 1,
                "ribbonGroupName": "Sponsors",
            },
            {
                "label": "My Regions",
                "filterKey": "RegionIds",
                "filterValue": "MyRegions",
                "subFilters": [],
                "count": 1,
                "ribbonGroupName": "Sponsors",
            },
            {
                "label": "My Networks",
                "filterKey": "NetworkIds",
                "filterValue": "MyNetworks",
                "subFilters": [],
                "count": 1,
                "ribbonGroupName": "Sponsors",
            },           
        ],
    },
    sortOptions: [
        {
            label: 'Sort by Recommended',
            key: 'recommended_asc',
            sortField: 'Recommended',
            direction: 'asc',
        },
        {
            label: 'Sort by Most Recent',
            key: 'startDateTime_asc',
            sortField: 'StartDateTime',
            direction: 'asc',
        },
        {
            label: 'Sort by Event Name',
            key: 'eventName_asc',
            sortField: 'EventName',
            direction: 'asc',
        },
    ],
    noResults: {
        label1: 'No events were found based on your selections',
        label2: 'Try removing some filters.',
    },
    noEventsResults: {
        label1: 'You are not currently registered for any events. ',
        label2: 'To enhance your experience, we suggest exploring a selection of recommended events by ',
        label3: 'clicking here.',
    },
    filterPillWithType: [
        {
            key: 'Chapters',
            label: 'Chapter | ',
        },
        {
            key: 'Regions',
            label: 'Region | ',
        },
    ],
    hostTypeAheadFDefault: [
        {
            key: 'Chapters',
            placeHolder: 'Type chapter name',
        },
        {
            key: 'Networks',
            placeHolder: 'Type network name',
        },
        {
            key: 'Regions',
            placeHolder: 'Select region',
        },
    ],
    locationFilterDefaults: {
        countryDefault: {
            label: 'Any Country',
            filterValue: 'countryDefault',
        },
        stateDefault: {
            label: 'Any State/Province/Region',
            filterValue: 'stateDefault',
        },
        cityDefault: {
            label: 'Any City',
            filterValue: 'cityDefault',
        },
    },
    dateFilters: {
        defaultFilter: {
            label: 'All Active Events',
            filterValue: 'dateDefault',
            count: 1,
            filterKey: 'dateDefault',
        },
        dateRange: {
            label: 'Date Range',
            filterValue: 'dateRange',
            count: 1,
            filterKey: 'dateRange',
        },
        dateRangeStartFilter: {
            "label": "Start Date Earliest",
            "filterKey": "StartDateTimeRangeFrom",
            "filterValue": "",
            "isTypeAhead": false,
            "isDropdown": false,
            "subFilters": [],
            "count": 0,
            "ribbonGroupName": "Dates",
        },
        dateRangeEndFilter: {
            "label": "Start Date Latest",
            "filterKey": "StartDateTimeRangeTo",
            "filterValue": "",
            "isTypeAhead": false,
            "isDropdown": false,
            "subFilters": [],
            "count": 0,
            "ribbonGroupName": "Dates",
        },
    },
    hostFilterDefaults: {
        chapterDefault: {
            label: 'My Chapters Only',
            filterValue: 'MyChapters',
            parentKey: 'Chapters',
        },
        networkDefault: {
            label: 'All Networks',
            filterValue: 'NetworkIds',
            parentKey: 'Networks',
        },
        regionDefault: {
            label: 'All Regions',
            filterValue: 'RegionIds',
            parentKey: 'Regions',
        },
        regionDropDownDefault: {
            label: 'Select region',
            filterValue: '',
            parentKey: 'Regions',
        },
    },
};

export const facetTitles = [
    {
        name: 'My Chapters',
        key: ypoEventConstant.constant.keys.myChapters,
        active: true,
    },
    {
        name: 'My Networks',
        key: ypoEventConstant.constant.keys.myNetworks,
        active: true,
    },
    {
        name: 'Event Topic',
        key: ypoEventConstant.constant.keys.eventFocusFilter,
        active: true,
    },
    {
        name: 'Learning Goal',
        key: ypoEventConstant.constant.keys.lifelongLearningFilter,
        active: true,
    },
    {
        name: 'Location',
        key: ypoEventConstant.constant.keys.locationFilter,
        active: true,
    },
    {
        name: 'Date',
        key: ypoEventConstant.constant.keys.datesFilter,
        active: true,
    },
    {
        name: 'Host',
        key: ypoEventConstant.constant.keys.hostFilter,
        active: true,
    },
    {
        name: 'Who Can Attend',
        key: ypoEventConstant.constant.keys.whoCanAttendFilter,
        active: true,
    },
    {
        name: 'Vouchers',
        key: ypoEventConstant.constant.keys.voucherFilter,
        active: true,
    },
];

export const defaultYpoEventSort = ypoEventConstant.sortOptions[0];

export const createMyEventsFilters = (currentUserId) => {
    const myEvents = {};
    myEvents.label ="My Events";
    myEvents.filterValue = currentUserId;
    myEvents.filterKey = ypoEventConstant.constant.keys.attendeeIds;
    myEvents.ribbonGroupName = "Sponsors";
    myEvents.isTypeAhead = false;
    myEvents.isDropdown = false;
    myEvents.subFilters = [];
    myEvents.count = 0

    return myEvents;
};

export const createYpoEventState = () => {
    const result = {};
    if (facetTitles && facetTitles.length) {
        facetTitles.forEach((item) => {
            result[item.key] = [];
        });
    }
    return result;
};

export const createChapterFiltersForUser = (communities) => {
    const result = [];
    const chapters = communities
        .filter(community => community.communityType && community.communityType.toLowerCase() === 'chapter');
    if (chapters && chapters.length) {
        chapters.forEach((chapter) => {
            result.push({
                label: chapter.name || '',
                filterKey: 'Chapters',
                filterValue: chapter.name || '',
                count: 1,
                ribbonGroupName: 'Sponsors',
                parentKey: 'sponsors',
            });
        });
    }
    return result;
};

export const sortAppliedFiltersAlphabetically = (list) => {
    return list && list.length ? orderBy(list, ['label'], ['asc']) : [];
};

export const sortHostFilters = (list) => {
    const result = [];
    if (list && list.length) {
        const filteredList = {
            chapterList: sortAppliedFiltersAlphabetically(list
                .filter(item => item.filterKey && item.filterKey.toLowerCase().includes('chapter'))),
            networkList: sortAppliedFiltersAlphabetically(list
                .filter(item => item.filterKey && item.filterKey.toLowerCase().includes('network'))),
            regionList: sortAppliedFiltersAlphabetically(list
                .filter(item => item.filterKey && item.filterKey.toLowerCase().includes('region'))),
            globalHostFilter: list.filter(item => item.filterKey && item.filterKey.toLowerCase().includes('global')),
            myEventsHostFilter: list.filter(item => item.filterKey && item.filterKey.includes(ypoEventConstant.constant.keys.attendeeIds)),
        };
        Object.keys(filteredList).forEach((key) => {
            if (key.length) result.push(...filteredList[key]);
        });
    }
    return result;
};

export const getEventDate = (event) => {
    let result = "";
    if (event && event.startEventDate && event.endEventDate) {
        const { startEventDate, endEventDate } = event;
        const eventStartDate =
            startEventDate.date === endEventDate.date &&
            startEventDate.month === endEventDate.month &&
            startEventDate.year === endEventDate.year
                ? ""
                : startEventDate.date;
        const eventStartMonth =
            startEventDate.month === endEventDate.month &&
            startEventDate.year === endEventDate.year
                ? ""
                : startEventDate.month;
        const eventStartYear =
            startEventDate.year === endEventDate.year
                ? ""
                : startEventDate.year;
        let eventStart = `${eventStartDate} ${eventStartMonth} ${eventStartYear}`;

        const eventEnd = `${endEventDate.date} ${endEventDate.month} ${endEventDate.year}`;
        const separator = `${
            startEventDate.date !== endEventDate.date ||
            startEventDate.month !== endEventDate.month ||
            startEventDate.year !== endEventDate.year
                ? "-"
                : ""
        }`;

        result = `${eventStart} ${separator} ${eventEnd}`;

        if (
            startEventDate.month === endEventDate.month &&
            startEventDate.year === endEventDate.year
        ) {
            eventStart = eventStart.trim();
            const startString = `${eventStart}${separator}`.trim();
            result = `${startString}${eventEnd}`;
        }
    }
    return result;
};

export const getEventDuration = (event) => {
    let duration = "";
    let eventDay = "";
    if (event && event.startEventDate && event.endEventDate) {
        const { startEventDate, endEventDate } = event;
        const timeZone = event.eventTimeZone ? `| ${event.eventTimeZone}` : "";
        eventDay =
            startEventDate.date === endEventDate.date &&
            startEventDate.month === endEventDate.month &&
            startEventDate.year === endEventDate.year
                ? startEventDate.day
                : `${startEventDate.day} - ${endEventDate.day}`;

        const eventTimeStamp = startEventDate.time && endEventDate.time
            ? `${startEventDate.time} - ${endEventDate.time}`
            : "";

        duration = `${eventDay} | ${eventTimeStamp} ${timeZone}`;
    }
    return duration;
};

export const getEventLocation = (event) => {
    const {
        state,
        city,
        country,
        locationType,
    } = event;
    let location = city || "";
    if (city && (state || country)) location = `${location},`;
    if (state) {
        location = `${location} ${state}`;
    } else if (country) {
        location = `${location} ${country}`;
    }
    location = location.trim();
    if (
        locationType &&
        locationType.includes(ypoEventConstant.label.VIRTUAL)
    ) {
        return location
            ? `${location} + ${ypoEventConstant.label.VIRTUAL}`
            : ypoEventConstant.label.VIRTUAL;
    }
    return location;
};

export const filterPillsForDateRange = (pills) => {
    let result = [];
    if (pills && pills.length) {
        const dates = pills.filter(p => p.ribbonGroupName === 'Dates');
        result = pills.filter(p => p.ribbonGroupName !== 'Dates');
        if (dates && dates.length) {
            if (dates.length > 1) {
                const newDate = getEventDates(dates[0].filterValue, dates[1].filterValue);
                result.push({ ...dates[0], label: newDate });
            } else {
                result.push(...dates);
            }
        }
    }
    return result;
};

export const hasSubFiltersCount = (filterFacet) => {
    let result = false;
    if (filterFacet && filterFacet.subFilters && filterFacet.subFilters.length) {
        const hassubFilters = filterFacet.subFilters.find(facet => facet.count);
        result = !!hassubFilters;
    }
    return result;
};

export const generateFiltersForCategory = (filterFacet, previouslyAppliedFilters) => {
    let result = [];

    let availableFilters = filterFacet && filterFacet.filters ? filterFacet.filters : [];
    if (filterFacet && filterFacet.categories) {
        availableFilters = filterFacet.categories;
    }

    if (availableFilters.length && filterFacet.key) {
        if (filterFacet.key === ypoEventConstant.constant.keys.whoCanAttendFilter) {
            if (filterFacet.categories && filterFacet.categories.length) {
                result = [...filterFacet.categories];
            } else {
                availableFilters.forEach((filter) => {
                    if (filter && filter.subFilters && filter.subFilters.length) {
                        filter.subFilters.forEach((subFilter) => {
                            if (subFilter.count) {
                                result.push(subFilter);
                            }
                        });
                    }
                });
            }
        } else if (filterFacet.key === ypoEventConstant.constant.keys.locationFilter) {
            availableFilters.forEach((filter) => {
                if (filter) {
                    result.push(filter);
                }
            });
        } else if (filterFacet.key === ypoEventConstant.constant.keys.hostFilter) {
            availableFilters.forEach((filter) => {
                if (filter) {
                    const hasSubFilters = hasSubFiltersCount(filter);
                    if (filter.count || hasSubFilters) {
                        const newFilter = {
                            ...filter,
                            subFilters: filter.subFilters && filter.subFilters.length
                                ? filter.subFilters.sort((x, y) => x.isTypeAhead - y.isTypeAhead)
                                : [],
                        };
                        result.push(newFilter);
                    }
                }
            });
        } else if (filterFacet.key === ypoEventConstant.constant.keys.datesFilter) {
            availableFilters.forEach((filter) => {
                if (filter && filter.filterKey) {
                    result.push({
                        ...filter,
                        count: filter.filterKey.toLowerCase() === ypoEventConstant.constant.keys.startDateTimeRangeFrom.toLowerCase()
                            || filter.filterKey.toLowerCase() === ypoEventConstant.constant.keys.startDateTimeRangeTo.toLowerCase()
                            ? 0
                            : 1,
                    });
                }
            });
        } else {
            availableFilters.forEach((filter) => {
                if (filter && filter.count) {
                    const newFilter = {
                        ...filter,
                        subFilters: filter.subFilters && filter.subFilters.length
                            ? filter.subFilters.filter(item => item.count)
                            : [],
                    };
                    result.push(newFilter);
                }
            });
        }
    }

    if (result.length && previouslyAppliedFilters) {
        result.forEach((item) => {
            item.checked = !!(previouslyAppliedFilters.find((filter) => {
                return filter.filterKey && item.filterKey
                    && filter.filterValue && item.filterValue
                    && item.filterKey === filter.filterKey
                    && item.filterValue === filter.filterValue;
            }));

            if (item.filterKey && item.filterKey.toLowerCase()
                === ypoEventConstant.constant.keys.startDateTimeRangeFrom.toLowerCase()) {
                item.checked = !!(previouslyAppliedFilters.find((filter) => {
                    return filter.filterKey && filter.filterKey.toLowerCase()
                        === ypoEventConstant.constant.keys.startDateTimeRangeFrom.toLowerCase();
                }));
            }

            if (item.subFilters && item.subFilters.length) {
                if (filterFacet.key === ypoEventConstant.constant.keys.hostFilter) {
                    item.subFilters.forEach((subItem) => {
                        subItem.checked = !!(previouslyAppliedFilters.find((filter) => {
                            return filter.filterKey && subItem.filterKey
                                && (subItem.filterKey === filter.filterKey
                                || subItem.filterValue === filter.filterValue);
                        }));
                        if (subItem.filterKey === 'Chapters') {
                            subItem.checked = !!(previouslyAppliedFilters.find(filter => filter.isTypeAheadHostFilter && subItem.filterKey === filter.filterKey));
                        }
                    });
                } else {
                    item.subFilters.forEach((subItem) => {
                        subItem.checked = !!(previouslyAppliedFilters.find((filter) => {
                            return filter.filterKey && subItem.filterKey
                                && filter.filterValue && subItem.filterValue
                                && subItem.filterKey === filter.filterKey
                                && subItem.filterValue === filter.filterValue;
                        }));
                    });
                }
                if (!item.checked) {
                    item.checked = !!(item.subFilters.find(subItem => subItem.checked));
                }
            }
        });
    }
    return result;
};

export const determineFacetAvailability = (filterFacet) => {
    let result = false;
    if (filterFacet && filterFacet.categories && filterFacet.categories.length) {
        let hasAvailableCategory = filterFacet.categories.find(facet => facet.count);

        if (!hasAvailableCategory) {
            filterFacet.categories.forEach((subCategory) => {
                if (subCategory.subFilters && subCategory.subFilters.length) {
                    hasAvailableCategory = subCategory.subFilters.find(facet => facet.count);
                }
            });
        }
        result = !!hasAvailableCategory;
    }
    return result;
};

export const getEventFilterAccordions = (filterList, previouslySelectedFilters) => {
    const result = [];
    if (filterList && filterList.length) {
        filterList.forEach((filterItem) => {
            const facet = facetTitles.find(item => item.key === filterItem.key);
            const previouslyAppliedFilters =
                previouslySelectedFilters && previouslySelectedFilters.hasOwnProperty(filterItem.key)
                    ? [...previouslySelectedFilters[filterItem.key]]
                    : [];
            const categories = generateFiltersForCategory(filterItem, previouslyAppliedFilters);
            const facetHasAvailableCategories = determineFacetAvailability({ categories });
            if (facet && facet.active && facetHasAvailableCategories) {
                const filterFacet = {
                    title: facet.name || (filterItem.name || ''),
                    key: filterItem.key,
                    categories,
                };
                result.push(filterFacet);
            }
        });
    }
    return result;
};

export const getAccordionState = (facetFilters) => {
    const result = [];
    if (facetFilters && facetFilters.length) {
        facetFilters.forEach((facet) => {
            if (facet && facet.categories && facet.categories.length) {
                result.push(!!(facet.categories.find(category => category.checked)));
            }
        });
    }
    return result;
};

export const getSelectedFilterKeys = (filterState) => {
    const result = [];
    if (filterState && Object.keys(filterState).length) {
        Object.keys(filterState).forEach((facetKey) => {
           if (filterState[facetKey] && filterState[facetKey].length) {
              result.push(facetKey);
           }
        });
    }
    return result;
};

export const determineSelectedCountry = (countryList, appliedLocationFilters) => {
    let selectedCountry = { ...ypoEventConstant.locationFilterDefaults.countryDefault };
    if (appliedLocationFilters && appliedLocationFilters.length && countryList && countryList.length) {
        const previouslySelectedCountry = appliedLocationFilters.find((item) => {
            return item.filterKey && item.filterValue
                && item.filterKey.toLowerCase() === ypoEventConstant.constant.keys.countryState.toLowerCase()
                && !item.filterValue.includes('>');
        });
        if (previouslySelectedCountry && previouslySelectedCountry.filterValue) {
            selectedCountry = countryList.find(country => country.filterValue &&
                country.filterValue.toLowerCase() === previouslySelectedCountry.filterValue.toLowerCase());
        }
    }
    return selectedCountry;
};

export const determineSelectedStateOrCity = (appliedLocationFilters, locationKey) => {
    let result = locationKey && locationKey.toLowerCase() === ypoEventConstant.constant.keys.countryStateCity.toLowerCase()
        ? { ...ypoEventConstant.locationFilterDefaults.cityDefault }
        : { ...ypoEventConstant.locationFilterDefaults.stateDefault };

    if (appliedLocationFilters && appliedLocationFilters.length && locationKey) {
        const previouslySelected = appliedLocationFilters.find((item) => {
            return item.filterKey && item.filterValue
                && item.filterKey.toLowerCase() === locationKey.toLowerCase()
                && item.filterValue.includes('>');
        });
        if (previouslySelected) {
            result = { ...previouslySelected };
        }
    }
    return result;
};

export const getAvailableCities = (cityList, selectedCountryState) => {
    let result = cityList && cityList.length ? [...cityList] : [];
    if (selectedCountryState && selectedCountryState.filterValue
        && !selectedCountryState.filterValue.toLowerCase().includes('default')) {
        result = result.filter((city) => {
            return city.filterValue && city.filterValue.toLowerCase().includes(selectedCountryState.filterValue.toLowerCase());
        });
    }
    return result;
};

export const getLocationFilters = (locationFacet, previouslyAppliedFilters) => {
    const result = {
        locationTypes: [],
        countryList: [],
        stateList: [],
        cityList: [],
        previouslySelectedCountry: null,
        previouslySelectedState: null,
        previouslySelectedCity: null,
    };

    if (locationFacet && locationFacet.categories) {
        // creating 'Virtual' and 'In-Person' filters
        const availableLocationTypes = locationFacet.categories
            .filter(item => item.filterKey
                && item.filterKey.toLowerCase() === ypoEventConstant.constant.keys.locationType.toLowerCase());
        result.locationTypes = availableLocationTypes ? orderBy(availableLocationTypes, ['label'], ['desc']) : [];

        // creating options for Country dropdown
        const availableCountryStates = locationFacet.categories
            .find(item => item.filterKey &&
                item.filterKey.toLowerCase() === ypoEventConstant.constant.keys.countryState.toLowerCase());
        result.countryList = availableCountryStates && availableCountryStates.subFilters
            && availableCountryStates.subFilters.length
            ? [ypoEventConstant.locationFilterDefaults.countryDefault, ...availableCountryStates.subFilters]
            : [];

        // setting selected country based on previously applied country filter
        result.previouslySelectedCountry = determineSelectedCountry(result.countryList, previouslyAppliedFilters);

        // setting previously selected State and available States based on previously applied Country and State
        result.previouslySelectedState =
            determineSelectedStateOrCity(previouslyAppliedFilters, ypoEventConstant.constant.keys.countryState);
        result.stateList = result.previouslySelectedCountry && result.previouslySelectedCountry.subFilters
            && result.previouslySelectedCountry.subFilters.length
                ? [ypoEventConstant.locationFilterDefaults.stateDefault, ...result.previouslySelectedCountry.subFilters]
                : [ypoEventConstant.locationFilterDefaults.stateDefault];

        // setting previously selected City and Available City list based on selection
        result.previouslySelectedCity =
            determineSelectedStateOrCity(previouslyAppliedFilters, ypoEventConstant.constant.keys.countryStateCity);

        // creating options for City
        const availableCities = locationFacet.categories
            .find(item => item.filterKey &&
                item.filterKey.toLowerCase() === ypoEventConstant.constant.keys.countryStateCity.toLowerCase());

        const selectedParentToFilterCity = result.previouslySelectedState
            && result.previouslySelectedState.filterValue === ypoEventConstant.locationFilterDefaults.stateDefault.filterValue
            ? result.previouslySelectedCountry
            : result.previouslySelectedState;

        result.cityList = availableCities && availableCities.subFilters
            && availableCities.subFilters.length
                ? getAvailableCities(availableCities.subFilters, selectedParentToFilterCity)
                : [];
        result.cityList.unshift(ypoEventConstant.locationFilterDefaults.cityDefault);
        //
    }

    return result;
};

export const myChapterEventsOnly = (filtersFromRoute) => {
    let result = false;
    // return true only if host/chapter/mychapteronly filter is applied, if there are any other host filters return false.
    if (filtersFromRoute && filtersFromRoute.hasOwnProperty(ypoEventConstant.constant.keys.hostFilter)
        && filtersFromRoute[ypoEventConstant.constant.keys.hostFilter].length) {
        result = !!((filtersFromRoute[ypoEventConstant.constant.keys.hostFilter]
            .find(filter => filter.filterKey === ypoEventConstant.constant.myChapterDefaultFilter.filterKey
            && filter.filterValue === ypoEventConstant.constant.myChapterDefaultFilter.filterValue))
            && !filtersFromRoute[ypoEventConstant.constant.keys.hostFilter].some(item => item.filterKey && !item.filterKey.toLowerCase().includes('chapter')));
      }
    return result;
};

export const isMyEventsVisible = (filtersFromRoute, currentUserId) => {
    let result = false;
    // return true only if my events filter is applied, if there are any other filters return false.
    if (filtersFromRoute && filtersFromRoute.hasOwnProperty(ypoEventConstant.constant.keys.hostFilter)
        && filtersFromRoute[ypoEventConstant.constant.keys.hostFilter].length) {
        result = !!((filtersFromRoute[ypoEventConstant.constant.keys.hostFilter]
                .find(filter => filter.filterKey && filter.filterKey === ypoEventConstant.constant.keys.attendeeIds
                    && filter.filterValue && filter.filterValue.toLowerCase() === currentUserId.toLowerCase() ))
            && !filtersFromRoute[ypoEventConstant.constant.keys.hostFilter].some(item => item.filterKey
                && !item.filterKey.includes(ypoEventConstant.constant.keys.attendeeIds)));
    }
    return result;
};
export const getFilteredString = (gtmFilters) => {
    const result = [];
    Object.keys(gtmFilters).forEach(key => {
        const filters = gtmFilters[key];
        if (filters.length > 0) {
            filters.forEach(filter => {
                const parentKey = filter.parentKey || key;
                if (filter.filterValue) {
                    result.push(`${parentKey} : ${filter.filterValue}`);
                }
            });
        }
    });

    return result ? result.join('|') : result;
};
export const getUpdatedFiltersToApply = (filterItem, parentKey, filtersFromRoute) => {
    let filterToPush = filtersFromRoute ? { ...filtersFromRoute } : {};
    if (filterItem && parentKey) {
        if (filtersFromRoute) {
            if (filtersFromRoute.hasOwnProperty(parentKey)) {
                const filterAlreadyExist = filtersFromRoute[parentKey]
                    .find(item => (item.filterKey === filterItem.filterKey && item.filterValue === filterItem.filterValue) ||
                        (parentKey === ypoEventConstant.constant.keys.myChapters
                            || parentKey === ypoEventConstant.constant.keys.myNetworks )
                        );
                filterToPush = {
                    ...filterToPush,
                    [parentKey]: [
                        ...filtersFromRoute[parentKey],
                        filterItem,
                    ],
                };
                if (filterAlreadyExist) {
                    let newFilters = filterToPush[parentKey]
                        .filter(item => item.filterValue !== filterAlreadyExist.filterValue);

                    //removing all subFilters if parent category is deselected
                    if (filterAlreadyExist.subFilters && filterAlreadyExist.subFilters.length
                        && (parentKey === ypoEventConstant.constant.keys.eventFocusFilter
                        || parentKey === ypoEventConstant.constant.keys.lifelongLearningFilter)) {
                        newFilters = newFilters
                            .filter(filter => filter.filterValue && filterAlreadyExist.label
                                && !filter.filterValue.includes(filterAlreadyExist.label));
                    }
                    filterToPush = {
                        ...filterToPush,
                        [parentKey]: newFilters,
                    };
                }
            } else {
                filterToPush = { ...filterToPush, [parentKey]: [filterItem] };
            }
        } else {
            filterToPush = {
                [parentKey]: [
                    { ...filterItem },
                ],
            };
        }
    }
  return filterToPush;
};

export const getUpdatedFiltersBasedOnLocation = (newFilter, appliedLocationFilters, allAppliedFilters, locationFilterKey) => {
    let result = Object.keys(allAppliedFilters).length ? { ...allAppliedFilters } : {};
    if (newFilter && appliedLocationFilters && locationFilterKey) {
        if (appliedLocationFilters && appliedLocationFilters.length) {
            if (
                locationFilterKey === ypoEventConstant.constant.keys.countryState
                || locationFilterKey === ypoEventConstant.locationFilterDefaults.countryDefault.filterValue
                || locationFilterKey === ypoEventConstant.locationFilterDefaults.stateDefault.filterValue
                || locationFilterKey.toLowerCase() === ypoEventConstant.constant.keys.inPersonLocationType.toLowerCase()
            ) {
                // removing all applied country and state if the selected filter is
                // in-person, country, default country or default state
                result[ypoEventConstant.constant.keys.locationFilter] = appliedLocationFilters
                    .filter(item => item.filterKey && !item.filterKey.toLowerCase().includes('country'));
            } else if (locationFilterKey === ypoEventConstant.locationFilterDefaults.cityDefault.filterValue
                || locationFilterKey === ypoEventConstant.constant.keys.countryStateCity) {
                // removing all applied city if the selected filter is default city
                result[ypoEventConstant.constant.keys.locationFilter] = appliedLocationFilters
                    .filter(item => item.filterKey && !item.filterKey.toLowerCase().includes('countrystatecity'));
            }
        }

        // after resetting the location filters state - handling add/delete of newly applied location filter
        if (locationFilterKey !== ypoEventConstant.locationFilterDefaults.countryDefault.filterValue &&
            locationFilterKey !== ypoEventConstant.locationFilterDefaults.stateDefault.filterValue &&
            locationFilterKey !== ypoEventConstant.locationFilterDefaults.cityDefault.filterValue) {
            result = getUpdatedFiltersToApply(
                newFilter,
                ypoEventConstant.constant.keys.locationFilter,
                result,
            );
        }
    }

    return result;
};

export const getUpdatedFiltersBasedOnHost = (newFilter, appliedHostFilters, allAppliedFilters, hostFilterKey) => {
    let result = Object.keys(allAppliedFilters).length ? { ...allAppliedFilters } : {};
    if (newFilter && appliedHostFilters && hostFilterKey) {
        if (appliedHostFilters && appliedHostFilters.length) {
            if (hostFilterKey === ypoEventConstant.hostFilterDefaults.chapterDefault.parentKey) {
                result[ypoEventConstant.constant.keys.hostFilter] = appliedHostFilters
                    .filter(item => item.filterKey && !item.filterKey.toLowerCase().includes('chapter'));
            }
            if (hostFilterKey === ypoEventConstant.hostFilterDefaults.networkDefault.parentKey) {
                result[ypoEventConstant.constant.keys.hostFilter] = appliedHostFilters
                    .filter(item => item.filterKey && !item.filterKey.toLowerCase().includes('network'));
            }
            if (hostFilterKey === ypoEventConstant.hostFilterDefaults.regionDefault.parentKey) {
                result[ypoEventConstant.constant.keys.hostFilter] = appliedHostFilters
                    .filter(item => item.filterKey && !item.filterKey.toLowerCase().includes('region'));
            }
        }

        if ((hostFilterKey === ypoEventConstant.hostFilterDefaults.chapterDefault.parentKey ||
            hostFilterKey === ypoEventConstant.hostFilterDefaults.networkDefault.parentKey ||
            hostFilterKey === ypoEventConstant.hostFilterDefaults.regionDefault.parentKey) &&
            newFilter && newFilter.checked && newFilter.subFilters && newFilter.subFilters.length) {
            return result;
        }

        if (hostFilterKey === ypoEventConstant.hostFilterDefaults.chapterDefault.parentKey) {
            const chapterFilterToApply = newFilter ? { ...newFilter } : {};
            if (chapterFilterToApply && Object.keys(chapterFilterToApply).length) {
                if (chapterFilterToApply.subFilters && chapterFilterToApply.subFilters.length) {
                    const defaultFilter = chapterFilterToApply.subFilters
                        .find(item => item.filterValue === ypoEventConstant.hostFilterDefaults.chapterDefault.filterValue);
                    if (!defaultFilter) {
                        result = getUpdatedFiltersToApply(
                            chapterFilterToApply.subFilters[0],
                            ypoEventConstant.constant.keys.hostFilter,
                            result,
                        );
                    } else if (defaultFilter && !appliedHostFilters.some(item => item.filterValue === defaultFilter.filterValue)
                        ) {
                        result[ypoEventConstant.constant.keys.hostFilter].push(defaultFilter);
                    }
                } else if (chapterFilterToApply && chapterFilterToApply.filterValue === ypoEventConstant.hostFilterDefaults.chapterDefault.filterValue
                        ) {
                    result[ypoEventConstant.constant.keys.hostFilter].push(chapterFilterToApply);
                } else {
                    result = getUpdatedFiltersToApply(
                        chapterFilterToApply,
                        ypoEventConstant.constant.keys.hostFilter,
                        result,
                    );
                }
            }
        } else if (hostFilterKey === ypoEventConstant.hostFilterDefaults.networkDefault.parentKey ||
            hostFilterKey === ypoEventConstant.hostFilterDefaults.regionDefault.parentKey) {
            result = getUpdatedFiltersToApply(
                newFilter && newFilter.subFilters && newFilter.subFilters.length ?
                    newFilter.subFilters.find(item => item.filterValue === ypoEventConstant.hostFilterDefaults.networkDefault.filterValue ||
                        item.filterValue === ypoEventConstant.hostFilterDefaults.regionDefault.filterValue)
                    : newFilter,
                ypoEventConstant.constant.keys.hostFilter,
                result,
            );
        } else if (newFilter.filterKey !== ypoEventConstant.constant.keys.globalEvent
            && newFilter.filterKey !== ypoEventConstant.constant.keys.attendeeIds
            && newFilter.filterKey !== ypoEventConstant.constant.keys.programOwner) {
            result[ypoEventConstant.constant.keys.hostFilter] = appliedHostFilters
                .filter(item => item.filterValue === ypoEventConstant.hostFilterDefaults.chapterDefault.filterValue ||
                    item.filterValue === ypoEventConstant.hostFilterDefaults.networkDefault.filterValue ||
                    item.filterValue === ypoEventConstant.hostFilterDefaults.regionDefault.filterValue);

            result = getUpdatedFiltersToApply(
                newFilter,
                ypoEventConstant.constant.keys.hostFilter,
                result,
            );
        } else {
            result = getUpdatedFiltersToApply(
                newFilter,
                ypoEventConstant.constant.keys.hostFilter,
                result,
            );
        }
    }

    return result;
};

export const createApplicableLocationFilters = (pillList, includeInPersonFilter) => {
    let result = pillList && pillList.length ? [...pillList] : [];
    const countryStateFilters = pillList
        .filter(item => item.filterKey
            && item.filterKey.toLowerCase() === ypoEventConstant.constant.keys.countryState.toLowerCase());
    const cityFilter = pillList
        .find(item => item.filterKey
            && item.filterKey.toLowerCase() === ypoEventConstant.constant.keys.countryStateCity.toLowerCase());

    if (!cityFilter) {
        if (countryStateFilters.length > 1) {
            result = pillList
                .filter(item => item.filterValue && (item.filterValue.includes('>')
                    || item.filterValue.toLowerCase() === ypoEventConstant.constant.keys.inPersonLocationType.toLowerCase()
                    || item.filterValue.toLowerCase() === ypoEventConstant.constant.keys.virtualLocationType.toLowerCase()));
        }
    } else {
        result = pillList
            .filter(item => item.filterValue && item.filterKey
                && (item.filterKey === ypoEventConstant.constant.keys.countryStateCity
                    || item.filterValue.toLowerCase() === ypoEventConstant.constant.keys.inPersonLocationType.toLowerCase()
                    || item.filterValue.toLowerCase() === ypoEventConstant.constant.keys.virtualLocationType.toLowerCase()));
    }

    if ((cityFilter || countryStateFilters.length) && !includeInPersonFilter) {
        result = result
            .filter(item => item.filterValue
                && item.filterValue.toLowerCase() !== ypoEventConstant.constant.keys.inPersonLocationType.toLowerCase());
    }

    return result;
};

export const filterStateAfterRemovingFilter = (selectedFilterState, filterPill) => {
    let newFilters = {};
    if (selectedFilterState && Object.keys(selectedFilterState).length
        && filterPill && filterPill.parentKey && filterPill.filterKey && filterPill.filterValue) {
        newFilters = { ...selectedFilterState };
        Object.keys(newFilters).forEach((key) => {
            if (key && newFilters.hasOwnProperty(key) && newFilters[key].length
                && key.toLowerCase() === filterPill.parentKey.toLowerCase()) {
                if (key.toLowerCase() === ypoEventConstant.constant.keys.locationFilter.toLowerCase()
                    && filterPill.filterKey.toLowerCase().includes('country')) {
                    newFilters[key] = newFilters[key]
                        .filter(item => item.filterKey
                            && !item.filterKey.toLowerCase().includes('country'));
                } else if ((key.toLowerCase() === ypoEventConstant.constant.keys.eventFocusFilter.toLowerCase()
                    || key.toLowerCase() === ypoEventConstant.constant.keys.lifelongLearningFilter.toLowerCase())
                    && filterPill.parentKey && filterPill.parentKey.toLowerCase() === key.toLowerCase()
                    && filterPill.subFilters && filterPill.subFilters.length) {
                    newFilters[key] = newFilters[key]
                        .filter(filter => filter.filterValue && filterPill.label
                            && !filter.filterValue.includes(filterPill.label));
                } else if (key.toLowerCase() === ypoEventConstant.constant.keys.datesFilter.toLowerCase()
                    && filterPill.parentKey
                    && filterPill.parentKey.toLowerCase() === ypoEventConstant.constant.keys.datesFilter.toLowerCase()) {
                    newFilters[key] = [];
                } else if (key.toLowerCase() === ypoEventConstant.constant.keys.hostFilter
                    && filterPill.parentKey
                    && filterPill.parentKey.toLowerCase() === ypoEventConstant.constant.keys.hostFilter.toLowerCase()) {
                    const defaultChaptersApplied = newFilters[key]
                        .filter(item => item.filterKey && item.filterKey.toLowerCase().includes('chapter'));
                    // checking the length to be only be 2 with default 'My Chapters Only' applied else it won't care
                    if (defaultChaptersApplied && defaultChaptersApplied.length === 2
                        && filterPill.filterKey.toLowerCase().includes('chapter')
                        && defaultChaptersApplied
                            .some(filter => filter.filterValue === ypoEventConstant.hostFilterDefaults.chapterDefault.filterValue)) {
                        newFilters[key] = newFilters[key]
                            .filter(item => item.filterKey && !item.filterKey.toLowerCase().includes('chapter'));
                    } else {
                        newFilters[key] = newFilters[key]
                            .filter(item => item.filterValue
                                && item.filterValue.toLowerCase() !== filterPill.filterValue.toLowerCase());
                    }
                } else {
                    newFilters[key] = newFilters[key]
                        .filter(item => item.filterValue
                            && item.filterValue.toLowerCase() !== filterPill.filterValue.toLowerCase());
                }
            }
        });
    }
    return newFilters;
};

export const setHostTypeAheadLabel = (appliedHostFilters, typeAheadKey) => {
    if (appliedHostFilters && appliedHostFilters.length && typeAheadKey) {
      const previouslySelectedTypeAhead = appliedHostFilters.find((item) => {
          return item.filterKey && item.filterValue
              && item.filterKey.toLowerCase() === typeAheadKey.filterKey.toLowerCase()
              && item.isTypeAhead;
      });

    return previouslySelectedTypeAhead && previouslySelectedTypeAhead.filterValue ?
            previouslySelectedTypeAhead.filterValue :
            ypoEventConstant.hostTypeAheadFDefault.find(item => item.key === typeAheadKey.filterKey).placeHolder;
    }
};

export const determineParentChildFilterToApply = (pillList) => {
    let result = pillList && pillList.length ? [...pillList] : [];
    if (pillList && pillList.length) {
        pillList.forEach((pill) => {
            if (pill && pill.filterValue && pill.filterValue.includes('>')) {
                const labelValues = pill.filterValue.split('>');
                const parentValue = `${labelValues[0]}*`;
                result = result
                    .filter(item => item.filterValue && !item.filterValue.toLowerCase().includes(parentValue.toLowerCase()));
            }
        });
    }
    return result;
};
